import React, { Component } from 'react';
import { pictureIcon, targetIcon, dot3Icon } from '@/lib/icons';
import { getGalleryLink,  galleryRouting } from "@/lib/utils.js";
import { useState } from 'react';
import Link from 'next/link';

export default function ApplicationGalleryTile(props) {
  let city_state = [];
  if(props.app_gallery.city)
    city_state.push(props.app_gallery.city)
  if(props.app_gallery.state)
    city_state.push(props.app_gallery.state)

  function ImageContent(props) {
    return (<div className='image-non-action'>
      <img src={props.app_gallery.image_url} alt={props.app_gallery.name + ' photo'} className='app-gallery-image'/>
      <div className='photo-count-container'>          
        { pictureIcon }<p>({props.app_gallery.photo_count})</p>
      </div>
      <div className='hot-spot-count-container'>          
        { targetIcon }<p>({props.app_gallery.product_count})</p>
      </div>
    </div>);
  }
  
  function MetaContent(props) {
    return (<>
      <h4 className='app-gallery-name'>{ pictureIcon }{ props.app_gallery.name }</h4>
      <p className='gallery-city-state'>{city_state.join(', ')}</p>
      <div className='app-gallery-contents-container'>
        { [{name: 'Applications', count: props.app_gallery.applications_count}, {name:'Spaces', count: props.app_gallery.spaces_count}].map((content, i) => {
            return <p className='app-gallery-content' key={i}>({content['count']}) {content['name']}</p>;
          })
        }
      </div>
      <div className='app-gallery-story' dangerouslySetInnerHTML={{__html: props.app_gallery.story}}></div>
    </>);
  }

  return (
    <div className='lexcms-gallery-tile '>
      { props.mobile ? (
          <Link {...galleryRouting(props.app_gallery) }>
            <a rel='noreferrer noopener' style={{cursor: 'pointer'}}>
              <div className='app-gallery-image-container'>
                <ImageContent {...props} />
              </div>
              <MetaContent {...props} />
            </a>
          </Link>
        ) :
        (
          <div className='lexcms-gallery-tile-desktop'>
            <div className="app-gallery-image-container">
              <ImageContent {...props} />
              <div className='overlay-action-buttons-container'>
                <Link  {...galleryRouting(props.app_gallery) }  >
                  <a className='overlay-action-button overlay-details-action-button' >
                    { dot3Icon } Details
                  </a>
                </Link>
              </div>
            </div>
            <MetaContent {...props} />
          </div>
        )
      }
    </div>
  )
}
